<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fFIWJS/tc-custom/9780226112251.jpg?1731785616435" alt="This image is the cover for the book Black and White Styles in Conflict"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Black and White Styles in Conflict
      </h1>
      <p class="bookDescription body article font2">
        <p>"Goes a long way toward showing a lay audience the value, integrity, and aesthetic sensibility of black culture, and moreover the conflicts which arise when its values are treated as deviant version of majority ones."—Marjorie Harness Goodwin, <i>American Ethnologist</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Kochman
      </h2>
      
      <p class="authorDescription body article">Please fill in author biography</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?48b93144